<template>
  <div class="pagination">
    <!-- <a-pagination v-model="currentPage" :total="total" :item-render="itemRender"></a-pagination> -->
    <a-pagination :currentPage="currentPage" :total="total" :show-total="total => `总共 ${total} 条`" @change="itemChange" :defaultPageSize="limitPage" :hideOnSinglePage="true"></a-pagination>
  </div>
</template>
<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    total: Number,
    limitPage: {
      type: Number,
      default: 10
    },
    pageType: String
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    itemRender (currentPage, type, originalElement) {
      if (type === 'prev') {
        return <a>上一页</a>
      } else if (type === 'next') {
        return <a>下一页</a>
      }
      return originalElement
    },
    itemChange (currentPage) {
      console.log(currentPage + ' vs ' + this.$parent.currentPage);
      console.log(this.$parent.limitStart);
      this.$parent.currentPage = currentPage;
      this.$parent.limitStart = (currentPage - 1) * this.limitPage;
      if (this.pageType == 'learn') {
        this.$parent.getLearnCategoryData();
      // } else if (this.pageType == 'themeactivity' || this.pageType == 'schoolnews') {
      } else if (['themeactivity', 'schoolnews', 'educationalnewsletter', 'exchangeactivities', 'internet', 'teams', 'liveonline', 'grandworks', 'mycollect', 'curriculum'].indexOf(this.pageType) > -1) {
        this.$parent.getData();
      }
    }
  }
}
</script>
<style lang="less" scoped>
.pagination{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 68px;
  & /deep/ .ant-pagination-item{
    & > a{
      color: #333;
    }
    &:focus, &:hover{
      border-color: #C16613;
    }
    &-active{
      background: #C16613;
      border-color: #C16613;
      & > a{
        color: #fff;
      }
    }
  }
}
</style>
